export default {"src":"/_next/static/media/relapse.mono.f757b5fe.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};